import { render, staticRenderFns } from "./PrefixesForm.vue?vue&type=template&id=7bde1fb5&lang=pug"
import script from "./PrefixesForm.vue?vue&type=script&lang=js"
export * from "./PrefixesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports